import React from 'react';
import { Grid } from '../../../../../components/Grid';
import { GridCell } from '../../../../../components/GridCell';
import { convertNumberToString } from '../../../../../utils/formatNumber';
import { formatKm } from '../../../../../utils/mask';

interface Props {
  data: any;
}

export const BusDatasheet = ({ data }: Props) => {
  const {
    year,
    yearFabrication,
    odometer,
    color,
    motor,
    fuel,
    seatsAmount,
    transmission,
    busType,
  } = data;

  const dataSheetLabel = 'f14 fw2 boulder ma0';
  const dataSheetValue = 'f14 fw4 abbey';

  const odometerFormatted = formatKm(convertNumberToString(odometer));

  return (
    <Grid className="flex-column-ns">
      <GridCell width={[1 / 2, 1]} className="flex flex-column flex-row-ns justify-between-ns">
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Ano</p>
          <b className={dataSheetValue}>
            {yearFabrication}/{year}
          </b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>KM</p>
          <b className={dataSheetValue}>{odometerFormatted || '--'}</b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Motor</p>
          <b className={dataSheetValue}>{motor}</b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24">
          <p className={dataSheetLabel}>Combustível</p>
          <b className={dataSheetValue}>{fuel}</b>
        </GridCell>
      </GridCell>
      <GridCell width={[1 / 2, 1]} className="flex flex-column flex-row-ns justify-between-ns">
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Cor</p>
          <b className={dataSheetValue}>{color}</b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Assentos</p>
          <b className={dataSheetValue}>{seatsAmount}</b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24 mb16">
          <p className={dataSheetLabel}>Transmissão</p>
          <b className={dataSheetValue}> {transmission}</b>
        </GridCell>
        <GridCell width={[1, 1 / 4]} className="pr24">
          <p className={dataSheetLabel}>Tipo</p>
          <b className={dataSheetValue}>{busType}</b>
        </GridCell>
      </GridCell>
    </Grid>
  );
};
